export interface TeamColorOption {
    value: string;
    label: string;
}

const COLOR_DEFINITIONS = [
    { cssVariable: '--color-sky', label: 'Kristallblau' },
    { cssVariable: '--color-pink', label: 'Hellrosa' },
    { cssVariable: '--color-lemon', label: 'Sportgelb' },
    { cssVariable: '--color-sand', label: 'Heliotroplila' },
    { cssVariable: '--color-mint', label: 'Lichtgrün' },
] as const;

export function findUnusedColor(usedColors: string[], allColors: string[]): string | undefined {
    return allColors.find(color => !usedColors.includes(color));
}

export function getTeamColorOptions(): TeamColorOption[] {
    const root = getComputedStyle(document.documentElement);
    const resolved = COLOR_DEFINITIONS.map(({ cssVariable, label }) => ({
        baseValue: root.getPropertyValue(cssVariable).trim(),
        label,
    }));

    return [
        ...resolved.map(({ baseValue, label }) => ({ value: baseValue, label })),
        ...resolved.map(({ baseValue, label }) => ({ value: `${baseValue}-circles`, label: `${label} mit Punkten` })),
        ...resolved.map(({ baseValue, label }) => ({ value: `${baseValue}-stripes`, label: `${label} mit Streifen` })),
        ...resolved.map(({ baseValue, label }) => ({ value: `${baseValue}-crosshatch`, label: `${label} mit Rautenmuster` })),
        ...resolved.map(({ baseValue, label }) => ({ value: `${baseValue}-grid`, label: `${label} mit Gitternetz` })),
    ];
}
